import React from 'react';
import { Typography } from '~/libs/ui/atoms/Typography';
import { Breadcrumbs, BreadcrumbsItem } from '~/libs/ui/atoms/Breadcrumbs';

export function Header() {
	const breadcrumbsList: BreadcrumbsItem[] = [{ name: 'Dostupnosti', link: '/availability' }, { name: 'Vyhledávání' }];

	return (
		<div className='w-full pt-2 pb-3.5 border-b border-gray-200 bg-cBlue-50'>
			<div className='max-w-[1260px] mx-auto px-[40px]'>
				<Breadcrumbs list={breadcrumbsList} />

				<div className='mb-3 flex w-full justify-between items-start'>
					<div className='pr-4'>
						<Typography level={2} weight='font-bold' color='cBlue-800'>
							Monitor dostupnosti
						</Typography>
					</div>
				</div>
			</div>
		</div>
	);
}
